import React, { useId } from 'react';
import { Link } from 'react-router-dom';
import './ShopPhotoDetails.css';

// Original food pixels: CSS reveals only the two pickles from the supplied tray photo.
export function PickleCutout({ className = '' }) {
  return <span className={`shop-pickle-cutout ${className}`} aria-hidden="true">
    <img src="/images/shop-details/catering-detail-source.jpg" alt="" width="750" height="1000" loading="lazy" decoding="async" />
  </span>;
}

function PickleIllustration() {
  const filterId = `shop-pickle-green-${useId().replace(/:/g, '')}`;
  return <span className="shop-pickle-illustration" aria-hidden="true">
    <svg width="0" height="0" focusable="false">
      <defs><filter id={filterId} colorInterpolationFilters="sRGB">
        {/* Same green-ink treatment as Deli Favorites; source artwork stays intact. */}
        <feColorMatrix type="matrix" values="0.82 0 0 0 0.18  0 0.64 0 0 0.36  0 0 0.94 0 0.06  0 0 0 1 0" />
      </filter></defs>
    </svg>
    <img src="/images/catalogue/vilmorin-cornichons.png" alt="" width="746" height="624" loading="lazy" decoding="async" style={{ filter: `url(#${filterId})` }} />
  </span>;
}

export function PiledHighFeature() {
  return <section className="shop-piled-high" aria-labelledby="piled-high-title">
    <div className="shop-piled-high__photo">
      <img src="/images/shop-details/sandwich-cross-section.jpg" alt="A close-up of Star Deli’s sliced corned beef, Swiss, tomato and lettuce on bread." width="844" height="500" loading="lazy" decoding="async" />
    </div>
    <div className="shop-piled-high__copy">
      <span className="shop-detail-kicker">From our counter</span>
      <h2 id="piled-high-title">Piled <br />high.</h2>
      <p>Your favorites.<br />Made your way.</p>
      <Link to="/menu#basic-sandwiches">Build your usual <span aria-hidden="true">↗</span></Link>
    </div>
  </section>;
}

export function CateringPhotoNote() {
  return <aside className="shop-catering-note" aria-labelledby="catering-photo-note-title">
    <div className="shop-catering-note__paper">
      <span className="shop-detail-kicker">Gather ’round</span>
      <h3 id="catering-photo-note-title">Made for sharing.</h3>
      <p>A little get-together. Or the whole crowd.</p>
    </div>
    <PickleIllustration />
  </aside>;
}
